const initialState = {};

export default function detailsReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
